import React, { PropsWithChildren } from 'react';
import { UseOnScreenProvider } from './useOnScreen';

export function WebProvider({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  return <UseOnScreenProvider>{children}</UseOnScreenProvider>;
}
